import { createAction } from '@reduxjs/toolkit';
export const getWorkspaces = createAction('stylovyze/workspaces/getWorkspaces');
export const getWorkspacesResolved = createAction('stylovyze/workspaces/getWorkspaces/resolved');
export const getWorkspacesRejected = createAction('stylovyze/workspaces/getWorkspaces/rejected');
export const addChartToWorkspace = createAction('stylovyze/workspaces/addChartToWorkspace');
export const addChartToWorkspaceResolved = createAction('stylovyze/workspaces/addChartToWorkspace/resolved');
export const addChartToWorkspaceRejected = createAction('stylovyze/workspaces/addChartToWorkspace/rejected');
